export default function (questionnaireId, initialDataInteractor) {
  initialDataInteractor.data.questionnaires.forEach(function (questionnaire, index) {
    if (questionnaire['id'] == questionnaireId) {
      initialDataInteractor.data.questionnaires.splice(index, 1);
    }
  });

  let foundQuestionnaireInstanceBatch = {};
  while (foundQuestionnaireInstanceBatch != undefined) {
    foundQuestionnaireInstanceBatch = initialDataInteractor.data.questionnaire_instance_batches.find(function (rib, index, batches) {
      if (rib.questionnaire_id == questionnaireId) {
        batches.splice(index, 1);
        return true;
      } else {
        return false;
      }
    })
  }
}